import { setConfigGroups } from '@customer/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import { MultiselectFilter } from './MultiselectFilter';
import { useMemo } from 'react';
import {
  ConfigurationGroupBasicModel,
  useGetConfigurationGroupsQuery,
} from '@customer/store/apis/configurationGroupsApi';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';

const useConfigGroupOptions = (): DropdownItemProps<string>[] => {
  const { data: configGroups } = useGetConfigurationGroupsQuery(undefined, {
    refetchOnMountOrArgChange: 60,
  });

  return useMemo(() => {
    return configGroups
      ? configGroups.map(({ id, name }: ConfigurationGroupBasicModel) => {
          const value = id.toString();
          return { key: value, value, stringValue: value, label: name };
        })
      : [];
  }, [configGroups]);
};

export const ConfigGroupsFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownMultiselectElement>) => {
  const { t } = useTranslation();

  return (
    <MultiselectFilter<string>
      filterName="configGroups"
      label={label ?? t('ConfigurationGroup')}
      action={setConfigGroups}
      elementRef={elementRef}
      useItemsHook={useConfigGroupOptions}
    />
  );
};

export default ConfigGroupsFilter;
